import React from 'react';

export default function Footer() {
  return (
    <footer className="center">
      <p>&copy; Slick's Slices {new Date().getFullYear()}</p>
    </footer>
  );
}
